navApp.default.controller('primaryNavController', [
  '$scope', 'NavDataService', function($scope, NavDataService) {
    return NavDataService.getPrimaryNav().then(function(results) {
      return $scope.branches = results;
    });
  }
]);
